import React, { useEffect, useState } from "react";
import { CategoryForm } from "./CategoryForm";
import axios from "axios";

const API = "http://localhost:5000/api/categories";
const API_KEY = process.env.REACT_APP_API_URL


const CategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ name: "", id: null });

  // Load categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axios.get(`${API_KEY}/api/categories`);
        if (Array.isArray(data)) {          
          setCategories(data);
        } else {
          console.error("Invalid response format:", data);
          setCategories([]);
        }
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isEdit = Boolean(form.id);
    const url = isEdit ? `${API_KEY}/api/categories/${form.id}` : `${API_KEY}/api/categories`;
    const method = isEdit ? "put" : "post";

    try {
      const { data } = await axios({
        method,
        url,
        headers: { "Content-Type": "application/json" },
        data: { name: form.name },
      });

      if (isEdit) {
        if (Array.isArray(categories)) {
          setCategories((prev) =>
            prev.map((cat) => (cat._id === data._id ? data : cat))
          );
        } else {
          console.error(
            "categories is not an array at submit time:",
            categories
          );
          setCategories([data]);
        }
      } else {
        setCategories((prev) => [...prev, data]);
      }

      setForm({ name: "", id: null });
    } catch (error) {
      console.error("Failed to submit form:", error);
    }
  };

  const handleDelete = async (id) => {    
    try {
      await axios.delete(`${API_KEY}/api/categories/${id}`);
      setCategories((prev) => prev.filter((cat) => cat._id !== id));
    } catch (error) {
      console.error("Failed to delete category:", error);
    }
  };

  const handleEdit = (cat) => {
    setForm({ name: cat.name, id: cat._id });
  };

  return (
    <div className="container py-5">
      <CategoryForm form={form} setForm={setForm} handleSubmit={handleSubmit} />

      <div
        className="card shadow mt-4"
        style={{ maxWidth: "600px", margin: "0 auto" }}
      >
        <div className="card-body">
          <h5 className="text-center text-primary mb-3">CATEGORIES LIST</h5>

          {categories.length > 0 ? (
            <ul className="list-group">
              {categories.map((cat) => (
                <li
                  key={cat._id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  {cat.name}
                  <div>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleEdit(cat)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(cat._id)}
                    >
                      Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-muted text-center">No categories available.</p>
          )}
        </div>

        <div className="text-center small text-muted py-2">
          © 2025 Category Manager
        </div>
      </div>
    </div>
  );
};

export default CategoryManager;
